import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { RootState } from 'types/state';

export const Title: React.FunctionComponent = () => {
  let path = useLocation().pathname.toLowerCase();
  let section = useSelector((state: RootState) => state.section.section.name) ?? '';
  let subsection = useSelector((state: RootState) => state.section.subsection.name) ?? '';

  useEffect(() => {
    let newTitle = 'eApp';

    if (path.includes('form')) { path = '/form'; }

    switch (path) {
      case '/error':
        newTitle += ' - Error';
        break;
      case '/instructions':
        newTitle += ' - Instructions';
        break;
      case '/help':
        newTitle += ' - Help';
        break;
      case '/login':
        newTitle += ' - Login';
        break;
      case '/form':
        section = section.charAt(0).toUpperCase() + section.slice(1);

        // special case for /form/package/errors
        if (section === 'Review' && subsection === '') { subsection = 'errors'; }

        const subsections = subsection.split('/').map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join(' - ');

        newTitle += ` - ${section}`;
        if (subsections !== '' && section !== subsections) { newTitle += ` - ${subsections}`; }
        break;
      case '/accessdenied':
        newTitle += ' - Access Denied';
        break;
      case '/locked':
        newTitle += ' - Submitted';
        break;
      case '/token':
        newTitle += ' - Logged Out';
        break;
      default:
        break;
    }

    if (document.title !== newTitle) { document.title = newTitle; }
  }, [path, section, subsection]);

  return null;
};
